webpackJsonp([251060473113344],{

/***/ 1649:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"AnalyticsData","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"data","type":{"kind":"LIST","name":null,"ofType":{"kind":"OBJECT","name":"AnalyticsDataRow","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"field","type":{"kind":"ENUM","name":"AnalyticsField","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-analytics-data-612823db9410db7b1a92.js